var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "el-section" },
    [
      _vm.isLoading
        ? _c(
            "div",
            {
              staticClass:
                "emd-container _highlight_header _header_spaced _footer_spaced_sm",
            },
            [
              _c(
                "section",
                { staticClass: "eu-pa_6 eu-align_center" },
                [_c("emd-loader", { attrs: { type: "_invert" } })],
                1
              ),
            ]
          )
        : _c("invites-content", {
            attrs: {
              isLoading: _vm.isLoading,
              items: _vm.items,
              pagination: _vm.pagination,
              totalItems: _vm.totalItems,
              action: _vm.action,
              alert: _vm.alert,
            },
            on: { openModal: _vm.openModal, resetAlert: _vm.resetAlert },
          }),
      _vm.modalOpenned
        ? _c("modal-password", {
            attrs: { callback: _vm.actionInvite },
            on: { cancel: _vm.closeModal },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }